import React, {useRef} from "react";
import {styled} from "@mui/material/styles";

export default function RouterContainer({children, ...props}) {
    const scrollLockedElementRef = useRef(null)

    return (
        <Container ref={scrollLockedElementRef} {...props}>
            {children}
        </Container>
    );
}

const Container = styled('div')({
    position: 'relative',
    width: '100%',
});
